import React from 'react';
import { Container, Typography, Box, Button, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
// import { Header } from '../components/Header'; // REMOVED
import ExploreIcon from '@mui/icons-material/Explore';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Link } from 'react-router-dom'; // Use Link for navigation

// 🛑 NEW: Import the video file
import CommunityVideo from '../assets/community_video.mp4'; 

// NEW IMPORTS for the Homepage Sections:
import { HowItWorks } from '../components/HowItWorks';
import { TopicSelector } from '../components/TopicSelector';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';

export const Home = () => {
  const theme = useTheme();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };
  
  return (
    <>
        {/* HERO SECTION */}
        <Container 
            maxWidth="xl" 
            sx={{ 
              minHeight: '80vh', 
              display: 'flex', 
              flexDirection: 'column', 
              justifyContent: 'center', 
              textAlign: 'center', 
              py: 8 
            }}
        >
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              {/* Hero Section: Big mission title */}
              <motion.div variants={itemVariants}>
                <Typography 
                  variant="h1" 
                  component="h1"
                  sx={{ 
                    mb: 2, 
                    fontSize: { xs: '2.5rem', md: '4rem' },
                    fontWeight: 800,
                    color: theme.palette.text.primary,
                  }}
                >
                  A space for the community to <br />
                  <Box component="span" sx={{ color: theme.palette.primary.main }}>speak, learn,</Box> and <Box component="span" sx={{ color: theme.palette.secondary.main }}>grow together.</Box>
                </Typography>
              </motion.div>

              {/* Subtitle / Mission */}
              <motion.div variants={itemVariants}>
                <Typography 
                  variant="h5" 
                  sx={{ mb: 4, color: theme.palette.text.secondary }}
                >
                  Shift the mindset of the community by giving people **knowledge, connection, and energetic support**.
                </Typography>
              </motion.div>

              {/* CTA Buttons */}
              <motion.div variants={itemVariants}>
                <Box sx={{ mt: 4, '& button': { mx: 1, my: 1 } }}>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    startIcon={<ExploreIcon />}
                    component={Link}
                    to="/resources"
                  >
                    Start Exploring Resources
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    color="secondary"
                    startIcon={<ChatBubbleOutlineIcon />}
                    component={Link}
                    to="/community"
                    sx={{ borderColor: theme.palette.secondary.main }}
                  >
                    Join a Chat
                  </Button>
                </Box>
              </motion.div>
              
              {/* Illustration / Community Graphic - Replaced Placeholder with Video */}
              <motion.div variants={itemVariants}>
                 <Box 
                    sx={{ 
                        mt: 8, 
                        height: 400, // Increased height for better video display
                        borderRadius: 4, 
                        overflow: 'hidden', // Ensures video stays within the rounded corners
                        width: '100%',
                        boxShadow: 3
                    }}
                 >
                    <video 
                        autoPlay 
                        loop 
                        muted 
                        playsInline // Required for autoplay on some mobile browsers
                        style={{ 
                            width: '100%', 
                            height: '100%', 
                            objectFit: 'cover' // Ensures video fills the box without stretching
                        }}
                    >
                        {/* Use the imported variable as the source */}
                        <source src={CommunityVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                 </Box>
              </motion.div>

            </motion.div>
        </Container>
        
        {/* NEW SECTION 1: How It Works */}
        <HowItWorks />

        {/* NEW SECTION 2: Topic Selector */}
        <TopicSelector />

        {/* NEW SECTION 3: FAQ */}
        <FAQ />
        
        {/* FOOTER */}
        <Footer />
    </>
  );
};